// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on.
// Insights (A18U9): where the member has the `insights` feature the loader warms the charts through the same
// queryOptions the screen reads; without it the address goes to the tasks list, as the banner shows no Insights there.
// Its PageHeader row names the page (E22U6): the shell draws no context's glacier over it from 600 px.
import { ids } from '@orca/api-client/testIds'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../../../components/ui/page-header'
import { taskInsightsQuery } from '../../../../features/tasks/queries'
import { TaskInsights } from '../../../../features/tasks/TaskInsights'
import '../../../../features/tasks/strings'
import { accessQuery } from '../../../../shared/access/access'
import { Part } from '../../../../shared/shell/StatePart'

export const Route = createFileRoute('/o/$orgSlug/tasks/insights')({
  staticData: { screenId: 'TasksInsightsScreen', access: 'feature insights assigned' },
  loader: async ({ context: { queryClient, membership }, params }) => {
    const access = await queryClient.ensureQueryData(accessQuery(membership.orgId)).catch(() => null)
    if (access?.features?.insights !== true) throw redirect({ to: '/o/$orgSlug/tasks', params, replace: true })
    void queryClient.prefetchQuery(taskInsightsQuery(membership.orgId))
    return { orgId: membership.orgId }
  },
  component: TasksInsightsScreen,
})

function TasksInsightsScreen() {
  const { t } = useTranslation()
  const { orgId } = Route.useLoaderData()
  const { orgSlug } = Route.useParams()
  return (
    <main data-testid={ids.tasksInsights.root} className="flex flex-col gap-(--stack-lg)">
      <PageHeader title={t('tasks.insights')} />
      <Part testId={ids.tasksInsights.skeleton}>
        <TaskInsights orgId={orgId} orgSlug={orgSlug} />
      </Part>
    </main>
  )
}
